import React, { useMemo } from "react";
import moment from "moment";
import * as constants from "../../../constants/components/authentication";
import UICheckbox from "./UICheckbox";
import UISelect from "./UISelect";
import UIPhoneNumber from "./UIPhoneNumber";
import UIInput from "./UIInput";
import UITextarea from "./UITextarea";
import UISelectSearch from "./UISelectSearch";

import "./styles.scss";

const convertRangeValue = (value, type) => {
    if (type === constants.INPUT_TYPE_DATE) {
        return moment.unix(value).format('YYYY-MM-DD')
    }
    if (type === constants.INPUT_TYPE_TIME) {
        return moment.unix(value).format('HH:mm:ss');
    }

    return value;
}

export default ({
    $locale,
    type,
    name,
    description,
    value,
    defaultValue,
    onChange,
    label,
    isLabelHidden = false,
    options,
    error,
    defaultOptionTitle = 'Выбрать из списка',
    errorName = '',
    placeholder = '',
    color = '',
    required = false,
    isDisclaimer = false,
    isOptionsDisabled = false,
    isPasswordType = false,
    isPasswordVisible = false,
    onClickInputButton = () => {},
    hasAlignment = true,
    noOptionsMessage,
    OptionComponent,
    optionCancel,
    ...props
}) => {

    const labelClassName = [(required ? ' input-required' : ''), (error ? 'error' : '')].join(' ');

    const inputProps = useMemo(() => {
        if (type === 'number') {
            return props;
        }

        return {
            ...props,
            minLength: props.min,
            maxLength: props.max || props.maxLength,
        };
    }, [props]);

    if (props[constants.INPUT_PROPS_REGEXP] && !props[constants.INPUT_PROPS_PATTERN]) {
        props[constants.INPUT_PROPS_PATTERN] = props[constants.INPUT_PROPS_REGEXP];
    }

    if (constants.INPUT_TYPE_CHECKBOX === type.toLowerCase()) {
        return (
            <UICheckbox
                name={name}
                labelClassName={labelClassName}
                label={label}
                type={type}
                value={value}
                required={required}
                error={error}
                onChange={onChange}
                isDisclaimer={isDisclaimer}
                hasAlignment={hasAlignment}
                props={props}
            />
        );
    }

    if (constants.INPUT_TYPE_DISCLAIMER === type.toLowerCase()) {
        return (
            <UICheckbox
                name={name}
                labelClassName={labelClassName}
                label={description}
                type='checkbox'
                value={value}
                required={required}
                error={error}
                onChange={onChange}
                isDisclaimer={isDisclaimer}
                hasAlignment={hasAlignment}
                props={props}
            />
        );
    }

    if (constants.INPUT_TYPE_SELECT === type.toLowerCase()) {
        return (
            <UISelect
                $locale={$locale}
                name={name}
                value={value}
                defaultOptionTitle={defaultOptionTitle}
                options={options}
                labelClassName={labelClassName}
                label={label}
                required={required}
                error={error}
                errorName={errorName}
                onChange={onChange}
                isOptionsDisabled={isOptionsDisabled}
                color={color}
                props={props}
            />
        );
    }

    if (constants.INPUT_TYPE_SELECT_OTHER === type.toLowerCase()) {
        return (
            <UISelect
                $locale={$locale}
                name={name}
                value={value}
                defaultOptionTitle={defaultOptionTitle}
                options={options}
                labelClassName={labelClassName}
                label={label}
                required={required}
                error={error}
                errorName={errorName}
                onChange={onChange}
                isOptionsDisabled={isOptionsDisabled}
                color={color}
                isOther={true}
                inputProps={inputProps}
                props={props}
            />
        );
    }

    if (constants.INPUT_TYPE_SELECT_SEARCH === type.toLowerCase()) {
        return (
            <UISelectSearch
                $locale={$locale}
                name={name}
                value={value}
                defaultOptionTitle={defaultOptionTitle}
                options={options}
                labelClassName={labelClassName}
                label={label}
                required={required}
                error={error}
                errorName={errorName}
                onChange={onChange}
                isOptionsDisabled={isOptionsDisabled}
                noOptionsMessage={noOptionsMessage}
                color={color}
                placeholder={placeholder}
                props={props}
                OptionComponent={OptionComponent}
                optionCancel={optionCancel}
            />
        );
    }

    if (constants.INPUT_TYPE_TEL === type.toLowerCase()) {
        return (
            <UIPhoneNumber
                $locale={$locale}
                name={name}
                labelClassName={labelClassName}
                label={label}
                required={required}
                value={value}
                onChange={onChange}
                error={error}
                errorName={errorName}
                placeholder={placeholder}
                {...props}
            />
        )
    }

    if (constants.INPUT_TYPE_TEXTAREA === type.toLowerCase()) {
        return (
            <UITextarea
                name={name}
                labelClassName={labelClassName}
                label={label}
                required={required}
                value={value}
                onChange={onChange}
                error={error}
                errorName={errorName}
                color={color}
                placeholder={placeholder}
                props={inputProps}
            />
        );
    }

    if (props[constants.INPUT_PROPS_MIN]) {
        props[constants.INPUT_PROPS_MIN] = convertRangeValue(props[constants.INPUT_PROPS_MIN], type);
    }
    if (props[constants.INPUT_PROPS_MAX]) {
        props[constants.INPUT_PROPS_MAX] = convertRangeValue(props[constants.INPUT_PROPS_MAX], type);
    }

    return (
        <UIInput
            name={name}
            type={type}
            labelClassName={labelClassName}
            label={label}
            required={required}
            value={value}
            onChange={onChange}
            error={error}
            errorName={errorName}
            isPasswordType={isPasswordType}
            isPasswordVisible={isPasswordVisible}
            onClickInputButton={onClickInputButton}
            placeholder={placeholder}
            props={inputProps}
        />
    );
}
